module.exports = __webpack_public_path__ + "static/media/veiner-leatherworking-tool.5b36e589.webp";